module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex modal-form__titles"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('vue2.createusers.name')) + "*")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('vue2.createusers.login_options')) + " -\n      "), _c('span', {
    staticClass: "text-grey italic font-small"
  }, [_vm._v(_vm._s(_vm.$t('vue2.createusers.can_be_added_later')))])])]), _vm._v(" "), _vm._l((_vm.users), function(user, key) {
    return _c('div', {
      staticClass: "modal-form-group",
      class: {
        'hoverDanger': user.userHoverDanger
      }
    }, [_c('div', {
      staticClass: "create-form"
    }, [_c('div', {
      staticClass: "create-form__name"
    }, [_c('input', {
      staticClass: "namefield",
      class: {
        'inputError': !user.nameIsValid
      },
      attrs: {
        "type": "text",
        "placeholder": _vm.$t('vue2.createusers.placeholder_name')
      },
      on: {
        "input": function($event) {
          return _vm.checkAllForText($event.target.value, 'username', key)
        },
        "blur": function($event) {
          return _vm.validate(user, key)
        },
        "focus": function($event) {
          return _vm.unValidate(user, key)
        }
      }
    }), _vm._v(" "), (!user.nameIsValid) ? _c('span', {
      staticClass: "error-text"
    }, [_vm._v(_vm._s(_vm.$t('vue2.createusers.must_be_added')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "create-form__login"
    }, [(_vm.country.toLowerCase() === 'dk') ? _c('div', [_c('input', {
      staticClass: "UniLogin",
      class: {
        'inputPristine': user.unilogin.length < 1
      },
      attrs: {
        "type": "text",
        "placeholder": "uni-login"
      },
      on: {
        "blur": function($event) {
          return _vm.validate(user, key)
        },
        "focus": function($event) {
          return _vm.unValidate(user, key)
        },
        "input": function($event) {
          return _vm.checkAllForText($event.target.value, 'unilogin', key)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.country.toLowerCase() === 'no') ? _c('div', [_c('input', {
      staticClass: "feide",
      class: [{
        'inputPristine': user.feide.length < 1
      }, {
        'input--error': _vm.getIsUserWithSameFeide(user)
      }],
      attrs: {
        "type": "text",
        "placeholder": "feide"
      },
      on: {
        "blur": function($event) {
          return _vm.validate(user, key)
        },
        "focus": function($event) {
          return _vm.unValidate(user, key)
        },
        "input": function($event) {
          return _vm.checkAllForText($event.target.value, 'feide', key)
        }
      }
    }), _vm._v(" "), (_vm.getIsUserWithSameFeide(user)) ? _c('p', {
      staticClass: "error-text"
    }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.createusers.feide_is_already_used_for')) + " " + _vm._s(_vm.userWithSameFeide.name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
      class: [{
        'inputError': !user.validEmail
      }, {
        'inputPristine': user.email.length < 1
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.$t('vue2.createusers.mail')
      },
      on: {
        "blur": function($event) {
          return _vm.validateEmail(user, $event.target.value, key)
        },
        "keyup": function($event) {
          return _vm.checkEmailAndAllForText(user, $event.target.value, key)
        },
        "focus": function($event) {
          return _vm.unValidate(user, key)
        }
      }
    }), _vm._v(" "), (!user.validEmail) ? _c('span', {
      staticClass: "error-text"
    }, [_vm._v(_vm._s(_vm.$t('vue2.createusers.email_error_text')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "delete__user",
      on: {
        "click": function($event) {
          return _vm.removeUser(user)
        },
        "mouseenter": function($event) {
          return _vm.setHoverDanger(key)
        },
        "mouseleave": function($event) {
          return _vm.removeHoverDanger(key)
        }
      }
    }, [_c('span', {
      staticClass: "icon-cross2"
    })])])
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "add-more-button",
    on: {
      "click": _vm.pushNewUser
    }
  }, [_c('span', {
    staticClass: "plus--icon"
  }, [_vm._v("\n            +\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "add-more-button__text"
  }, [_vm._v(" " + _vm._s(_vm.$t('vue2.createusers.add_more')))])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78da7ab5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateCalendars/CreateUser/CreateUsersForm.vue
// module id = 1688
// module chunks = 1